const PIXEL_IDS = {
  meta: '647883611533369',
  tiktok: 'D3MFG9BC77U2Q086KLLG',
  snap: 'dc5f2543-7fcb-4dfa-bd92-5e225eedc636',
  twitter: 'qm62h',
};

// -------------------------------------------------------------------
// 🟦 Meta (Facebook / Instagram)
const loadMetaPixel = (pixelId) => {
  if (window.fbq) return;

  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
};

// -------------------------------------------------------------------
// 🟪 TikTok
const loadTikTokPixel = (pixelId) => {
  if (window.ttq) return;

  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
    ];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++)
      ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      var e = ttq._i[t] || [];
      for (var n in ttq.methods) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = i;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var o = d.createElement('script');
      o.type = 'text/javascript';
      o.async = true;
      o.src = i + '?sdkid=' + e + '&lib=' + t;
      var a = d.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(o, a);
    };
  })(window, document, 'ttq');

  window.ttq.load(pixelId);
  window.ttq.page();
};

// -------------------------------------------------------------------
// 🟨 Snapchat
const loadSnapPixel = (pixelId) => {
  if (window.snaptr) return;

  !(function (e, t, n) {
    if (e.snaptr) return;
    var a = (e.snaptr = function () {
      a.handleRequest
        ? a.handleRequest.apply(a, arguments)
        : a.queue.push(arguments);
    });
    a.queue = [];
    var s = 'script';
    var r = t.createElement(s);
    r.async = true;
    r.src = n;
    var u = t.getElementsByTagName(s)[0];
    u.parentNode.insertBefore(r, u);
  })(window, document, 'https://sc-static.net/scevent.min.js');

  window.snaptr('init', pixelId);
  window.snaptr('track', 'PAGE_VIEW');
};

// -------------------------------------------------------------------
// 🟩 X (Twitter)
const loadTwitterPixel = (pixelId) => {
  if (window.twq) return;

  !(function (e, t, n, s, u, a) {
    e.twq ||
      ((s = e.twq =
        function () {
          s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        }),
        (s.version = '1.1'),
        (s.queue = []),
        (u = t.createElement(n)),
        (u.async = true),
        (u.src = 'https://static.ads-twitter.com/uwt.js'),
        (a = t.getElementsByTagName(n)[0]),
        a.parentNode.insertBefore(u, a));
  })(window, document, 'script');

  window.twq('config', pixelId);
  window.twq('track', 'PageView');
};

// -------------------------------------------------------------------
// 🎯 Main Controller
export const initTrackingPixels = (utmSource) => {
  const source = utmSource?.toLowerCase();

  switch (source) {
    case 'meta':
    case 'facebook':
    case 'instagram':
      loadMetaPixel(PIXEL_IDS.meta);
      break;

    case 'tiktok':
      loadTikTokPixel(PIXEL_IDS.tiktok);
      break;

    case 'snap':
    case 'snapchat':
      loadSnapPixel(PIXEL_IDS.snap);
      break;

    case 'x':
    case 'twitter':
      loadTwitterPixel(PIXEL_IDS.twitter);
      break;

    default:
      console.warn('[Tracking] No matching pixel for source:');
      break;
  }
};
